import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0f573c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"100vh"} }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtext" }, [
  /*#__PURE__*/_createTextVNode(" Over the past 10 years, I have devoted much of my professional, academic and personal time to the development of projects in a range of diciplines. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("This spans everthing from front/backend development, video production and 3D Rendering, industrial design, and multi-diciplinary reserach. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtext" }, "These are some of those projects.", -1))
const _hoisted_5 = { style: {"margin-top":"20vh","text-align":"center"} }

import { ref, computed } from "vue";
import { isMobile } from "../common/common";
import Contents from "@/projectComps/Contents.vue";
import WasmTest from "@/projectComps/WasmTest.vue";
import MovieList from "@/projectComps/MovieList.vue";
import HowManyWeeks from "@/projectComps/HowManyWeeks.vue";
import VirtualCoffee from "@/projectComps/VirtualCoffee.vue";
import StillImages from "@/projectComps/StillImages.vue";
import VideoPlayers from "@/projectComps/VideoPlayers.vue";
import AStarMaze from "@/projectComps/AStarMaze.vue";

import { defineComponent } from "vue";
import StillImagesVue from "@/projectComps/StillImages.vue";
import VideoPlayersVue from "@/projectComps/VideoPlayers.vue";
const __default__ = defineComponent({
  name: "ProjectsView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [
        _createTextVNode("Projects")
      ])), [
        [_directive_motion_slide_visible_once_left]
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode(Contents),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(WasmTest),
      _createVNode(AStarMaze),
      _createVNode(VirtualCoffee),
      _createVNode(HowManyWeeks),
      _createVNode(MovieList),
      _createVNode(StillImages),
      (!_unref(isMobile)())
        ? (_openBlock(), _createBlock(VideoPlayers, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})